import React from 'react';
import Footer from '../common/footer';
import Header from '../common/header';
import PropTypes from 'prop-types';

const CreateApps = (props) => {
  const profileData = props.response;
  return (
    <div className='api-web api-web-my-profile'>
      <div className='container-boxed'>
        <Header />
        <div className='container d-flex f-d-c'>
          <div className='heading'>
            <img
              className='left-caret'
              src='/img/bg-top-left-small-caret.svg'
            />
            <div className='title-container'>
              <h1 className='bar-above'>My Profile</h1>
            </div>
          </div>
          <div className='main'>
            <div className='layout-left'>
              <form>
                <div className='my-profile-card card m-t-10 '>
                  <table>
                    <tr className='tr-name'>
                      <td className='td-left'>
                        <img src='/img/icons/mp-person.png' />
                      </td>
                      <td className='td-right'>
                        <div>
                          <label>Name</label>
                          <textarea
                            className='profile-name'
                            type='text'
                            id='name'
                            value={profileData.name || 'N/A'}
                            disabled
                          />
                        </div>
                      </td>
                    </tr>
                    <tr className='tr-angel-client-id'>
                      <td className='td-left'>
                        <img src='/img/icons/mp-angel-client-id.png' />
                      </td>
                      <td className='td-right'>
                        <div>
                          <label>AngelOne Client ID</label>
                          <input
                            type='text'
                            id='ABid'
                            value={profileData.clientcode || 'N/A'}
                            disabled
                          />
                        </div>
                      </td>
                    </tr>
                  </table>
                </div>
              </form>
            </div>
            <div className='layout-right'>
              <img
                className='main-img-v2'
                src='/img/my-profile-img-1.png'
                width='543'
                height='632'
              />
            </div>
          </div>
        </div>
        <Footer />
      </div>
    </div>
  );
};
export default CreateApps;

CreateApps.propTypes = {
  response: PropTypes.object.isRequired,
};
